// PostHog analytics utilities
import { env } from "../env";

export const getRouteMetadata = (pathname) => {
  const routeMap = {
    '/': { name: 'Feature Page', category: 'landing' },
    '/overview': { name: 'Overview Dashboard', category: 'dashboard' },
    '/neurolawgical-research': { name: 'Neurological Research', category: 'research' },
    '/legal-research': { name: 'Legal Research', category: 'research' },
    '/document-analyzer': { name: 'Document Analyzer', category: 'analysis' },
    '/translator': { name: 'Translator', category: 'tools' },
    '/judgement-finder': { name: 'Judgement Finder', category: 'search' },
    '/cases': { name: 'Subscribe Cases', category: 'cases' },
    '/calendar': { name: 'Calendar', category: 'productivity' },
    '/profile': { name: 'Profile', category: 'account' },
    '/wallet': { name: 'Wallet', category: 'billing' },
    '/login': { name: 'Login', category: 'auth' },
    '/register': { name: 'Register', category: 'auth' },
    '/chat': { name: 'Chat AI', category: 'ai' },
    '/custom-draft': { name: 'Custom Draft', category: 'drafting' },
    '/draft-pro': { name: 'Draft Pro', category: 'drafting' },
    '/fast-draft': { name: 'Fast Draft', category: 'drafting' },
    '/document-review': { name: 'Document Review', category: 'review' },
    '/event-extraction': { name: 'Event Extraction', category: 'analysis' },
    '/notifications': { name: 'Notifications', category: 'system' },
    '/feedback': { name: 'Feedback', category: 'support' },
    '/changelog': { name: 'Changelog', category: 'info' },
  };

  return routeMap[pathname] || { 
    name: pathname.replace('/', '').replace(/-/g, ' ') || 'Home', 
    category: 'unknown' 
  };
};

// Track feature usage with PostHog
export const trackFeatureUsage = (featureName, additionalData = {}) => {
  if (typeof window !== 'undefined' && window.posthog) {
    try {
      window.posthog.capture('feature_used', {
        feature_name: featureName,
        ...additionalData,
        timestamp: new Date().toISOString(),
      });
    } catch (error) {
      console.error('PostHog: Failed to track feature usage', error);
    }
  }
};

// Track user actions
export const trackUserAction = (action, data = {}) => {
  if (typeof window !== 'undefined' && window.posthog) {
    try {
      window.posthog.capture(action, {
        ...data,
        timestamp: new Date().toISOString(),
      });
    } catch (error) {
      console.error('PostHog: Failed to track user action', error);
    }
  }
};

// Track authentication events
export const trackAuthEvent = (event, userData = {}) => {
  if (typeof window !== 'undefined' && window.posthog) {
    try {
      window.posthog.capture(event, {
        ...userData,
        timestamp: new Date().toISOString(),
      });
    } catch (error) {
      console.error('PostHog: Failed to track auth event', error);
    }
  }
};

// Track errors
export const trackError = (errorType, errorData = {}) => {
  if (typeof window !== 'undefined' && window.posthog) {
    try {
      window.posthog.capture('error_occurred', {
        error_type: errorType,
        ...errorData,
        timestamp: new Date().toISOString(),
      });
    } catch (error) {
      console.error('PostHog: Failed to track error', error);
    }
  }
};

// Get safe user properties for PostHog
export const getSafeUserProperties = (user) => {
  if (!user) return {};
  
  return {
    email: user.email || '',
    name: user.name || '',
    role: user.role || '',
    registrationType: user.registrationType || '',
    credits: user.credits || 0,
    profileCompletionPercentage: user.profileCompletionPercentage || 0,
    userId: user._id || user.id || '',
  };
};

// Check if we should track (avoid localhost and development)
export const shouldTrack = () => {
  return env?.NODE_ENV === 'production' || 
         (env?.NODE_ENV === 'development');
};
